module.exports = __webpack_public_path__ + "static/media/menu-icon.fa630107.svg";